// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getReturnOrderAuditEvents } from '@/audit/api/get-return-order-audit-events';
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { Stack, Typography } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';

interface Props {
  returnOrderKey: string;
}

/**
 * Suspends while fetching the audit events for a single return order and
 * renders them in reverse chronological order using the shared
 * AuditEventListItem.
 */
export function ReturnOrderAuditList(props: Props) {
  const { data } = useSuspenseQuery({
    queryKey: ['return-order', props.returnOrderKey, 'audit'],
    queryFn: () => getReturnOrderAuditEvents(props.returnOrderKey),
    retry: false,
  });

  if (data.events.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No audit events recorded for this return order yet
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {data.events.map((event) => (
        <AuditEventListItem key={event.id} event={event} />
      ))}
    </Stack>
  );
}
